import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Modal } from '../../components/common/Modal';
import { Box, Typography, Card, CardContent, Grid, CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';
import api from '../../services/api';

export const VendorList = () => {
  const navigate = useNavigate();
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    loadVendors();
  }, []);

  const loadVendors = async () => {
    setLoading(true);
    try {
      const response = await api.get('/vendors/');
      if (response.data && response.data.data) {
        setVendors(response.data.data);
      }
    } catch (err) {
      console.error('Failed to load vendors:', err);
      toast.error(err.response?.data?.message || 'Failed to load vendors');
    } finally {
      setLoading(false);
    }
  };

  return (
    
      <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 }, maxWidth: '100%', width: '100%' }}>
        {/* Header */}
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
              Vendors
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage vendor accounts and permissions
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setIsModalOpen(true)}
            sx={{ textTransform: 'none', fontSize: '0.95rem', whiteSpace: 'nowrap' }}
          >
            Add Vendor
          </Button>
        </Box>

        <Modal
          isOpen={isModalOpen}
          title="Add New Vendor"
          onClose={() => setIsModalOpen(false)}
          onSubmit={() => {
            toast.success('Vendor added');
            setIsModalOpen(false);
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
            Add vendor form
          </Typography>
        </Modal>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : vendors.length === 0 ? (
          <Card sx={{ p: 4, textAlign: 'center' }}>
            <Typography color="text.secondary">No vendors found. Create your first vendor to get started.</Typography>
          </Card>
        ) : (
          <Grid container spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
            {vendors.map(vendor => (
              <Grid item xs={12} sm={6} md={4} key={vendor.id}>
                <Card
                  onClick={() => navigate(`/vendors/${vendor.id}`)}
                  sx={{
                    height: '100%',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 24px rgba(0,0,0,0.10)',
                    },
                  }}
                >
                  <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                      {vendor.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      {vendor.email}
                    </Typography>
                    {vendor.phone && (
                      <Typography variant="body2" color="text.secondary">
                        {vendor.phone}
                      </Typography>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    
  );
};
